import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Location } from "@angular/common";

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(public router: Router, private location: Location) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRole = route.data.expectedRole;
    let user = JSON.parse(localStorage.getItem('u'));    
    if (user == null) {
      return false;
    }
    if (expectedRole.indexOf(user.rol) == -1) {
      
      user = null;
      this.location.back();
      return false;
    }
    return true;
  }

 
}
